import { getGraphqlApiErrorReason } from '@ms/yammer-data';
import { getCurrentSessionUser } from '@ms/yammer-data/dist/domains/session/selectors';
import type { Store } from '@ms/yammer-data/dist/state/types';
import { FailedToLoad } from '@ms/yammer-error-components';
import UnlicensedUserError from '@ms/yammer-web-components/dist/error/UnlicensedUserError';
import UserActivationAutoRefresh from '@ms/yammer-web-components/dist/error/UserActivationAutoRefresh';
import React from 'react';

import type { YammerWebState } from '../../../state/types';

export const getErrorComponent = (store: Store<YammerWebState>): JSX.Element => {
  const state = store.getState();
  const { error } = getCurrentSessionUser(state);

  switch (getGraphqlApiErrorReason(error)) {
    case 'NO_YAMMER_LICENSE':
    case 'PRINCIPAL_NOT_FOUND':
      return <UnlicensedUserError />;
    case 'PENDING_USER':
      return <UserActivationAutoRefresh />;
    default:
      return <FailedToLoad />;
  }
};
